import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { MessageModalComponent } from '@app/shared/components/message-modal/message-modal.component';
import { DialogType } from '@app/shared/models/dialog-type';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(
    private modalService: BsModalService,
  ) { }

  showMessageDialog(title: string, message: string, onClose?: (result: any) => void) {
    const initialState = {title, message};
    const modalRef = this.modalService.show(MessageModalComponent, {initialState});
    if (onClose) {
      const subscription = this.modalService.onHide.subscribe((result: any) => {
        subscription.unsubscribe();
        onClose(result);
      });
    }
    return modalRef;
  }

  showConfirmDialog(title: string, message: string, onClose: (result: any) => void) {
    const initialState: Partial<MessageModalComponent> = {title, message, dialogType: DialogType.confirm};
    const modalRef = this.modalService.show(MessageModalComponent, {initialState});
    this.modalService.onHide.pipe(take(1)).subscribe((result: any) => {
      const response = modalRef.content?.confirmed ? 'confirm' : result; 
      onClose(response)
    });
    return modalRef;
  }

  showConfirmDialog$(title: string, message: string) {
    const initialState: Partial<MessageModalComponent> = {title, message, dialogType: DialogType.confirm};
    const modalRef = this.modalService.show(MessageModalComponent, {initialState});

    return new Observable<string>(subscriber => {
      this.modalService.onHide.pipe(take(1)).subscribe((result: string) => {
        const confirmed = modalRef.content?.confirmed;
        subscriber.next(confirmed ? 'confirm' : result);
        subscriber.complete();
      });
    });
  }
}
